export const categoriesColumns = [
  {
    accessorKey: "name", //access nested data with dot notation
    header: "Name",
  },
  // {
  //   accessorKey: "number_of_products",
  //   header: "Number of Products",
  // },
];

export const categories = [
  {
    category_id: 1,
    name: "Mobile Phones",
    number_of_products: 16724,
  },
  {
    category_id: 2,
    name: "Laptops",
    number_of_products: 533,
  },
  {
    category_id: 3,
    name: "Watches",
    number_of_products: 3563,
  },
  {
    category_id: 4,
    name: "Cameras",
    number_of_products: 2355,
  },
  {
    category_id: 5,
    name: "Electronics",
    number_of_products: 8563,
  },
  {
    category_id: 6,
    name: "Furniture",
    number_of_products: 4363,
  },
  {
    category_id: 7,
    name: "Clothing",
    number_of_products: 6434,
  },
  {
    category_id: 8,
    name: "Shoes",
    number_of_products: 26264,
  },
  {
    category_id: 9,
    name: "Sports Equipment",
    number_of_products: 3425,
  },
  {
    category_id: 10,
    name: "Beauty Products",
    number_of_products: 16724,
  },
];
